import React from 'react';
import './index.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Apps from './components/Apps';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Footer from './components/Footer';
import { useTheme } from './hooks/useTheme';
import { useReveal } from './hooks/useReveal';

function App() {
  const { theme, toggle } = useTheme();
  useReveal();

  return (
    <>
      <a className="skip" href="#sobre">Pular para o conteúdo</a>
      <Navbar theme={theme} onToggle={toggle} />
      <main>
        <Hero />
        <About />
        <Services />
        <Apps />
        <Projects />
        <Contact />
      </main>
      <Footer />
    </>
  );
}

export default App;
